export type KostFileNames =
  'KOSTEN' | 'ICD' | 'OPS' | 'FALL' | 'ENTGELTE' | 'FAB';

export const KOST_FILE_NAMES: KostFileNames[] = [
  'KOSTEN',
  'ICD',
  'OPS',
  'FALL',
  'ENTGELTE',
  'FAB',
];

/**
 * Matches an upper-cased path (e.g. a ZIP entry) whose file name contains the
 * KOST file name, optionally followed by `PLUS` or a `_`/`-` suffix, and ends
 * in `.CSV`. Written as an alternation so no quantifier wraps another
 * (star height 1): no catastrophic backtracking, and safe-regex accepts it.
 */
export const KOST_FILE_NAME_REG_EXP: { [name in KostFileNames]?: RegExp } = {
  KOSTEN: /KOSTEN(?:PLUS)?\.CSV$|KOSTEN[_-][^/]*\.CSV$/,
  ICD: /ICD(?:PLUS)?\.CSV$|ICD[_-][^/]*\.CSV$/,
  OPS: /OPS(?:PLUS)?\.CSV$|OPS[_-][^/]*\.CSV$/,
  FALL: /FALL(?:PLUS)?\.CSV$|FALL[_-][^/]*\.CSV$/,
  ENTGELTE: /ENTGELTE(?:PLUS)?\.CSV$|ENTGELTE[_-][^/]*\.CSV$/,
  FAB: /FAB(?:PLUS)?\.CSV$|FAB[_-][^/]*\.CSV$/,
};

/**
 * Map of available file types in p21 data and whether required.
 */
export const KOST_FILES_REQUIRED: { [kostFileName in KostFileNames]: boolean } =
  {
    KOSTEN: false,
    ICD: false,
    OPS: false,
    FALL: true,
    ENTGELTE: true,
    FAB: true,
  } as const;
